import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined,SaveOutlined,DeleteOutlined} from "@ant-design/icons";
import {seasonMonths} from "../../../../../../components/functions/Month";
import axios from "axios";
import {header} from "../../../../../../components/api/Header";
import {user_data} from "../../../../../../components/functions/usr";
import {NavLink} from "react-router-dom";
import swal from "sweetalert";
import { getEnv } from "../../../../../../lib/env";
function Add() {
    if(!user_data() || user_data().region_id != 16){
        window.location = '/limit/ptn/oylik'
    }
    const [hasData, setHasData] = useState(0)
    const [year, setYear] = useState('')
    const [lyear, setLyear] = useState(year)
    const [season, setSeason] = useState('veg')
    const [data, setData] = useState([])
    useEffect(()=>{
        const fetchData = async () => {
            const res = await axios.get(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitptn/oylik?year="+year+"&season="+season, header())
                .catch(e=>{
                    console.log("Xato",e)
                    alert("Server bilan aloqa yo'q")
                })
            if(res){
                setData(res.data.data)
                setHasData(res.data.hasData)
            }
        }
        if(year){
            fetchData()
        }
    },[year,season])
    const setHandler = (v,i,d) => {
        let dat = [...data]
        if(dat[i]){
            dat[i][d] = v
            setChanged(true)
        }
        setData(dat)
    }
    const [changed, setChanged] = useState(false)
    const doIt = async (action) => {
        const res = await axios.post(getEnv('REACT_APP_BASE_URL')+"/v1/region/limitptn/"+action,{data,year,season}, header())
            .catch(e=>{
                console.log("Xato",e)
                alert("Server bilan aloqa yo'q!")
            })
        if(res){
            if(res.data.status == 200){
                swal("Muvaffaqiyalti", res.data.message, 'success')
                window.location = "/limit/ptn/oylik"
            }else{
                swal("Xato", res.data.message, 'error')
            }
        }
    }
    return (
        <>
            <div className="table-content-top">
                <div className="table-top-left d-flex align-items-center">
                    <NavLink to="/limit/ptn/oylik" className="btn btn-sm btn-outline-primary d-flex align-items-center">
                        <ArrowLeftOutlined />&nbsp;&nbsp;&nbsp;Qaytish
                    </NavLink>
                    &nbsp;&nbsp;&nbsp;
                    {
                        changed ? <button className="btn btn-sm btn-outline-primary d-flex align-items-center" onClick={()=>doIt('saveoy')}>
                            Saqlash &nbsp;&nbsp;&nbsp;<SaveOutlined />
                        </button> :null
                    }
                    {
                        hasData ? <button className="btn btn-sm btn-outline-danger d-flex align-items-center" onClick={()=>doIt('deleteoy')}>
                            O'chirish &nbsp;&nbsp;&nbsp;<DeleteOutlined />
                        </button> :null
                    }

                </div>
                <ul className="table-top-right">

                    <li className="d-flex align-items-center">
                        <input type="number" className="form-control form-control-sm" min={2015} max={parseInt(new Date().toISOString().slice(0,4))+2} value={lyear} onChange={e=>setLyear(e.target.value)}/>
                        &nbsp;&nbsp;&nbsp;
                        <button className="btn btn-sm btn-outline-primary" onClick={()=>setYear(lyear)}>Ok</button>
                    </li>
                    <li>
                        <select className="form-select form-select-sm" onChange={e=>setSeason(e.target.value)} value={season}>
                            <option value="veg">Sug'orish mavsumi</option>
                            <option value="noveg">Nosug'orish mavsumi</option>
                        </select>
                    </li>

                </ul>
            </div>
            <div className="table-responsive tableFixHead">
                <table className="table table-bordered table-style">
                    <thead>
                    <tr>
                        <th colSpan={8}>Qoraqalpog‘iston Respublikasi va viloyatlarga {year}-yil {season == 'noveg' ? 'no' :null}sug‘orish mavsumida ajratilgan suv olish limiti</th>
                    </tr>
                    <tr>
                        <th scope="col">№</th>
                        <th scope="col">Hududlar nomi</th>
                        {
                            seasonMonths(season).map((s,i)=>{
                                return <th key={i}>{s}</th>
                            })
                        }
                    </tr>

                    </thead>
                    {
                        data.length > 0?
                            data.map((d,i) => {
                                return <tbody key={i}>
                                <tr>
                                    <th>{i+1}</th>
                                    <th>{d.name}</th>
                                    <th className="inserttr"><input className="insertable" type="number" value={d.m1} onChange={e=>setHandler(e.target.value,i,'m1')}/></th>
                                    <th className="inserttr"><input className="insertable" type="number" value={d.m2} onChange={e=>setHandler(e.target.value,i,'m2')}/></th>
                                    <th className="inserttr"><input className="insertable" type="number" value={d.m3} onChange={e=>setHandler(e.target.value,i,'m3')}/></th>
                                    <th className="inserttr"><input className="insertable" type="number" value={d.m4} onChange={e=>setHandler(e.target.value,i,'m4')}/></th>
                                    <th className="inserttr"><input className="insertable" type="number" value={d.m5} onChange={e=>setHandler(e.target.value,i,'m5')}/></th>
                                    <th className="inserttr"><input className="insertable" type="number" value={d.m6} onChange={e=>setHandler(e.target.value,i,'m6')}/></th>
                                </tr>
                                </tbody>
                            })
                            :null
                    }
                </table>
            </div>
        </>
    );
}

export default Add;

